<template>
  <div class="hotel-map">
    <div class="map-header">
      <h3>
        <i
          class="fa fa-times close-icon"
          @click="showMap(false)"
        />
        {{ brandName }} Exclusive Hotel
      </h3>
    </div>
    <div
      id="hotels-map"
      class="map-details"
    />
    <div
      id="map-legend"
      class="map-legend"
    >
      <img src="../../../../assets/images/maps-markers/green-pin.svg">Event Location
      <img src="../../../../assets/images/maps-markers/red-pin.svg">Exclusive Hotels
      <img src="../../../../assets/images/maps-markers/purple-pin.svg">Additional Hotels
    </div>
    <div
      v-if="selectedHotel"
      class="hotel-info"
    >
      <div class="close-card-icon">
        <i
          class="fa fa-times"
          @click="selectedHotel = null"
        />
      </div>
      <RetailHotelCard
        :hotel="selectedHotel"
      />
    </div>
    <div class="hotels-distance" />
  </div>
</template>

<script>

import RetailHotelCard from './retail_hotel_card'
import { mapMutations, mapGetters } from 'vuex'
import BlueMarker from '../../../../assets/images/maps-markers/blue-pin.svg'
import GreenPin from '../../../../assets/images/maps-markers/green-pin.svg'
import PurplePin from '../../../../assets/images/maps-markers/purple-pin.svg'
import RedPin from '../../../../assets/images/maps-markers/red-pin.svg'
/* global google */

export default {
  components: {
    RetailHotelCard
  },

  data() {
    return {
      eventLatLng: null,
      map: null,
      markers: [],
      selectedHotel: null,
      previousMarker: null,
      brandName: window.brand_name
    }
  },

  computed: {
    ...mapGetters('hotel', ['getLowestValue', 'getContractedHotels'])
  },

  watch: {
    map() {
      const contractedOnly = this.$store.state.hotel.contractedOnlyMap

      this.createEventMarker()

      if (contractedOnly) {
        this.createHotelMarkers(this.getContractedHotels)
      } else {
        this.createHotelMarkers(this.$store.state.hotel.hotels)
      }

      this.setZoomLevel()
    },
  },

  mounted() {
    try {
      const eventLat = this.$store.state.hotel.eventLatitude
      const eventLng = this.$store.state.hotel.eventLongitude
      this.eventLatLng = new google.maps.LatLng(eventLat, eventLng)
      this.map = new google.maps.Map(document.getElementById('hotels-map'), {
        zoom: 13,
        center: this.eventLatLng,
        fullscreenControl: false,
        streetViewControl: false
      })

      let legend = document.getElementById('map-legend')
      this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(legend)
    } catch (error) {
      alert(error)
    }
  },

  methods: {
    ...mapMutations('hotel', ['showMap', 'deselectHotel']),
    createEventMarker() {
      let marker = new google.maps.Marker({
        map: this.map,
        position: this.eventLatLng,
        icon: GreenPin
      })
      this.markers.push(marker)
    },
    createHotelMarkers(hotels) {
      for (let i = 0; i < hotels.length; i++) {
        const hotel = hotels[i]
        const hotelLocation = {
          lat: hotel.latitude,
          lng: hotel.longitude
        }
        const lowestValue = this.getLowestValue(hotel.id) / hotel.stayDuration
        const icon = hotel.contracted ? RedPin : PurplePin

        const marker = new google.maps.Marker({
          map: this.map,
          position: hotelLocation,
          animation: google.maps.Animation.DROP,
          label: {
            text: `$${(lowestValue.toFixed(0)).toString()}`,
            fontWeight: '1'
          },
          icon: {
            url: icon,
            labelOrigin: new google.maps.Point(12, 42)
          }
        })
        this.markers.push(marker)

        google.maps.event.addListener(marker, 'click', () => {
          if (this.previousMarker) {
            this.previousMarker.marker.setIcon(this.previousMarker.icon)
          }
          this.previousMarker = {marker: marker, icon: marker.getIcon()}
          marker.setIcon({
            url: BlueMarker,
            labelOrigin: new google.maps.Point(12, 42)
          })
          this.selectedHotel = hotel
        })
      }
    },
    setZoomLevel() {
      let bounds = new google.maps.LatLngBounds()
      this.markers.forEach(marker => {
        bounds.extend(marker.getPosition())
      })
      this.map.fitBounds(bounds)
    }
  }
}
</script>
